module.exports = __webpack_public_path__ + "img/Pausevideo.a771eb31.svg";